import * as React from 'react';
import { observer } from 'mobx-react';
import Dropzone = require('react-dropzone');
import { Button, FormControl, FormGroup, Panel } from 'react-bootstrap';
import { observable, action, computed } from 'mobx';
import { ApiStore } from '../../../stores/ApiStore';
import { inject, bind } from '../../../utils/decorators';
import VorgangFormularElement from '../VorgangFormularElement';
import { VorgangStore } from '../../../stores/VorgangStore';
import FaIcon from '../../site/FaIcon';

interface IFormularElementFileUpload {
  dokumentenBezeichnung: string;
  dokumentTitel?: string;
  text?: string;
  vorgangId?: string;
  wert?: string;
  name: string;
  element: VorgangFormularElement;
  onHandleValidation?: (validationstate: 'success' | 'warning' | 'error' | undefined) => void;
}

@observer
export default class FormularElementFileUpload extends React.Component<IFormularElementFileUpload, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable requestInProgress: boolean = false;
  @observable acceptedFile?: File;
  @observable dragging: boolean = false;
  @observable dokumentTitel: string = '';
  @observable uploadedFileName: string = '';

  componentDidMount() {
    this.dokumentTitel = this.props.dokumentTitel ? this.props.dokumentTitel : '';
    if (this.props.wert) {
      this.setUploadedFileName(this.props.wert);
    }
  }

  componentWillReceiveProps(nextProps: IFormularElementFileUpload) {
    if (nextProps.dokumentTitel !== this.props.dokumentTitel) {
      this.dokumentTitel = nextProps.dokumentTitel ? nextProps.dokumentTitel : '';
    }
  }

  @computed get FileUploaded() {
    return this.acceptedFile !== undefined;
  }

  @computed get fileSize() {
    return (this.acceptedFile && this.acceptedFile.size && !isNaN(this.acceptedFile.size))
      ? `(~${Math.ceil(10 * this.acceptedFile.size / 1024 / 1024) / 10} MB)`
      : '';
  }

  @bind @action handleFileDrop(accepted: File[]) {
    if (accepted.length > 0) {
      this.acceptedFile = accepted.shift();
    }
    this.handleSetDragging(false);
  }

  @bind @action handleFileDropRejected(rejected: File[]) {
    this.handleClearAcceptedFile();
    this.handleSetDragging(false);
  }

  @bind @action handleClearAcceptedFile() {
    this.acceptedFile = undefined;
  }

  @bind @action clear() {
    this.acceptedFile = undefined;
  }

  @bind @action setUploadedFileName(value: string) {
    this.uploadedFileName = value;
    if (this.props.onHandleValidation) {
      this.props.onHandleValidation('success');
    }
  }

  @bind @action setRequesInProgress(value: boolean) {
    this.requestInProgress = value;
  }

  @action handleSetDragging(dragging: boolean) {
    this.dragging = dragging;
  }

  @bind async handleUpload() {
    if ((this.acceptedFile !== undefined) && (this.dokumentTitel !== '')) {
      const { vorgangId } = this.props;
      if (!vorgangId) {
        return;
      }
      this.setRequesInProgress(true);
      const response = await this.apiStore.vorgangDateiUpload(vorgangId , this.dokumentTitel, this.acceptedFile);
      if (response.ok) {
        this.setUploadedFileName(this.acceptedFile.name);
        this.handleClearAcceptedFile();
        // this.vorgangStore.loadVorgang(vorgangId);
        // @todo: Visuelles update
      }
      this.setRequesInProgress(false);
    }
  }

  renderUploadStatus() {
    if (this.uploadedFileName !== '') {
      return (
        <div className="text-center value-success" style={{marginBottom: '10px'}}>Hochgeladenes Dokument: {this.uploadedFileName}</div>
      );
    } else {
      return (
        <div className="text-center value-error" style={{marginBottom: '10px'}}>Es wurde noch kein Dokument hochgeladen</div>
      );
    }
  }

  renderFileArea() {
    if (this.acceptedFile) {
      return (
        <div className="text-center">
          Ausgewählte Datei: {this.acceptedFile.name} ({Math.ceil(10 * this.acceptedFile.size / 1024 / 1024) / 10} MB)
        </div>
      );
    } else {
      if (this.uploadedFileName === '') {
        return (
          <div className="text-center">
            <div>{this.props.text}</div>
            <div style={{fontSize: '3em'}}><FaIcon icon="cloud-upload" /></div>
            <div>Datei auswählen oder per Drag&Drop auf die Fläche fallen lassen.<br/></div>
          </div>
        );
      } else {
        return (
          <div className="text-center">Das Dokument wurde erfolgreich im Vorgang hinterlegt.</div>
        );
      }
    }
  }
  render() {
    // tslint:disable-next-line:no-any
    let dropZone: any;

    return (
      <div>
        <Dropzone
          accept=".pdf,.docx,.tif,.tiff,.xlsx,.jpg,.jpeg,.png"
          ref={ref => dropZone = ref}
          disableClick={true}
          className={`upload-dropzone ${this.dragging ? 'upload-dropzone-dragging' : ''}`}
          style={{margin: 'inherit', padding: '0px'}}
          onDragEnter={() => this.handleSetDragging(true)}
          onDragLeave={() => this.handleSetDragging(false)}
          onDropAccepted={this.handleFileDrop}
          onDropRejected={this.handleFileDropRejected}
        >
        <Panel
          className={this.uploadedFileName === '' ? 'formular-element-upload-fehlt' : 'formular-element-upload-vorhanden'}
          footer={(
            <div className="text-center">
              {this.acceptedFile ? (
                <div>
                <Button className="btn-sm" disabled={this.requestInProgress} onClick={this.handleClearAcceptedFile}>Abbrechen</Button>
                <Button className="btn-sm" bsStyle="primary" disabled={this.requestInProgress} onClick={this.handleUpload}>Datei hochladen</Button>
                </div>
              ) : (
                <Button className="btn-sm" onClick={() => dropZone.open()}>{this.uploadedFileName === '' ? 'Datei auswählen' : 'Neue Datei auswählen'}</Button>
              )}
            </div>
          )}
        >
            {this.renderUploadStatus()}
            {this.renderFileArea()}
            <FormGroup>
              {/* Hochgeladene Datei als unsichtbares Feld übermitteln, wird beim Speichern in den Formular-Daten hinterlegt und kann später wieder angezeigt werden */}
              <FormControl type="hidden" name={this.props.name} value={this.uploadedFileName}/>
            </FormGroup>
          </Panel>
        </Dropzone>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/formularelemente/FormularElementFileUpload.tsx